export default function MarginBetweenSection() {
  return (
    <div className="h-9 phone2:h-11 phone3:h-12 tablet1:h-14 tablet2:h-16 desktop1:h-12"></div>
  );
}
